import { render, staticRenderFns } from "./TomarCantidad.vue?vue&type=template&id=1ccacf56&scoped=true&"
import script from "./TomarCantidad.vue?vue&type=script&lang=js&"
export * from "./TomarCantidad.vue?vue&type=script&lang=js&"
import style0 from "./TomarCantidad.vue?vue&type=style&index=0&id=1ccacf56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccacf56",
  null
  
)

export default component.exports